/**
 * Detect if the user is on a mobile device
 */
export const isMobileDevice = (): boolean => {
  // Check if window is available (for SSR safety)
  if (typeof window === "undefined") {
    return false;
  }

  // Check user agent for mobile indicators
  const userAgent = window.navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    "android",
    "webos",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "windows phone",
  ];

  const isMobileUA = mobileKeywords.some((keyword) =>
    userAgent.includes(keyword)
  );

  // Also check for touch support and small screen size
  const hasTouchScreen =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 768;

  // Consider it mobile if UA matches OR (has touch AND small screen)
  return isMobileUA || (hasTouchScreen && isSmallScreen);
};

/**
 * Get detailed device information
 */
export const getDeviceInfo = () => {
  const userAgent = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /Android/.test(userAgent);
  const isMobile = isMobileDevice();

  return {
    isMobile,
    isIOS,
    isAndroid,
    isDesktop: !isMobile,
    userAgent,
  };
};
